export const TIME_BLOCKS_TO_EXCLUDE = ["outOfOffice", "oof", "focusTime"];
